/**
 * 用户图像组件
 */

import { Avatar, } from 'antd';
import cookie from 'react-cookies';
import CNF from '../incs/Config';

const XAvatar = () => {
    return (<>
        {
            cookie.load(CNF.cookies.keyAvatarUrl) ? (
                <Avatar
                    size='middle'
                    src={cookie.load(CNF.cookies.keyAvatarUrl) ? CNF.ossApi + cookie.load(CNF.cookies.keyAvatarUrl) : ''}
                />
            ) : (
                <Avatar
                    style={{
                        color: '#FFFFFF',
                        verticalAlign: 'middle',
                        backgroundColor: CNF.themeColors[1]
                    }}
                    size='middle'
                >
                    {cookie.load(CNF.cookies.keyId) ? cookie.load(CNF.cookies.keyId).substr(0, 1).toUpperCase() : 'U'}
                </Avatar>
            )
        }
    </>
    )
}
export default XAvatar;